<template>
  <v-row>
    <v-col cols="12">
      <v-data-table
        :headers="headers"
        :items="items"
        :options.sync="options"
        :server-items-length="totalItems"
        :loading="loading"
        loading-text="Cargando..."
        class="elevation-1"
        :expanded.sync="expanded"
        show-expand
        item-key="id"
        :footer-props="footerOptions"
        single-expand
      >
        <template v-slot:top>
          <v-toolbar
            flat
            color="white"
          >
            <v-toolbar-title>{{ title }}</v-toolbar-title>
            <v-divider
              class="mx-4"
              inset
              vertical
            />
            <v-spacer />
            <v-text-field
              v-on:input="debounceInput"
              label="Buscar"
              single-line
              hide-details
            />
          </v-toolbar>
        </template>
        <template v-slot:item.action="{ item }">
          <v-tooltip bottom>
            <template v-slot:activator="{ on }">
              <v-icon
                :color="themeColor"
                @click="openModalDelete(item)"
                v-on="on"
              >
                mdi-delete
              </v-icon>
            </template>
            <span>Eliminar</span>
          </v-tooltip>
        </template>
        <template v-slot:expanded-item="{ headers, item }">
          <td :colspan="headers.length" v-if="item.servicio">
            Servicio
            <b>{{item.servicio}}</b>
            <br />
            <b>{{item.cantidad}} folios</b>
            <br />
            Licencia: {{item.codigo}}
          </td>
          <td :colspan="headers.length" v-else>
            <v-row>
              <v-col>No hay licencias asignadas.</v-col>
            </v-row>
          </td>
        </template>
        <template v-slot:no-data>
          <v-label>No se encontraron resultados.</v-label>
          <br />
          <v-btn :color="themeColor" @click="reset">Limpiar búsqueda</v-btn>
        </template>
      </v-data-table>
    </v-col>
    <v-dialog
        v-model="dialog"
        max-width="620"
      >
      <v-card>
        <v-card-title class="headline">
          ¿Estás seguro de que quieres eliminar este registro?
        </v-card-title>
        <v-card-actions>
          <v-spacer />
          <v-btn
            color="red darken-1"
            text
            @click="dialog = false"
          >
            Cancelar
          </v-btn>
          <v-btn
            color="green darken-1"
            text
            :loading="toggleStatusDelete"
            @click.prevent="deleteItem()"
          >
            Aceptar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
import { mapGetters } from 'vuex';
import * as _ from 'underscore';

export default {
  middleware: 'auth',
  props: {
    id: { default: '' },
    action: { default: '' },
  },
  data: () => ({
    expanded: [],
    loading: false,
    editedIndex: -1,
    options: {},
    search: '',
    message: '',
    items: [],
    type: '',
    totalItems: 0,
    footerOptions: { 'items-per-page-options': [10, 20, 30, 40, 50] },
    dialog: false,
    toggleStatus: false,
    toggleStatusDelete: false,
    selectedService: '',
    services: [],
    assignable: true,
    headers: [
      {
        text: 'Nombre',
        value: 'nombre',
        align: 'left',
        sortable: true,
      },
      {
        text: 'Tipo',
        value: 'tipo',
        align: 'left',
        sortable: true,
      },
      {
        text: 'Marca',
        value: 'marca',
        align: 'left',
        sortable: true,
      },
      {
        text: 'Modelo',
        value: 'modelo',
        align: 'left',
        sortable: true,
      },
      {
        text: 'Serial',
        value: 'serial',
        align: 'left',
        sortable: true,
      },
      {
        text: 'ID',
        value: 'id_dispositivo',
        align: 'left',
        sortable: true,
      },
      {
        text: 'Acciones',
        value: 'action',
        sortable: false,
      },
    ],
    title: 'Dispositivos',
  }),
  computed: {
    ...mapGetters({
      user: 'auth/user',
      themeColor: 'theme/themeColor',
    }),
    apiURL() {
      return `/api/catalogs/dealers/${this.user.dealer_id}/devices`;
    },
    apiURLDevice() {
      return '/api/catalogs/devices';
    },
  },

  watch: {
    options: {
      handler() {
        this.refreshTable();
      },
      deep: true,
    },
    search: {
      handler() {
        this.refreshTable();
      },
      deep: true,
    },
    apiURL: {
      handler() {
        this.refreshTable();
      },
      deep: true,
    },
  },

  mounted() {
    window.axios.get('/api/catalogs/getAllServices').then((response) => {
      this.services = response.data.items;
    });
    if (!this.can('eliminar_dispositivo')) {
      this.headers.splice(this.headers.findIndex(({ text }) => text === 'Acciones'), 1);
    }
  },
  methods: {
    debounceInput: _.debounce(function d(e) {
      this.search = e;
    }, 500),
    refreshTable() {
      this.getDataFromApi().then((data) => {
        this.items = data.items;
        this.totalItems = data.total;
      });
    },
    getDataFromApi() {
      this.loading = true;
      return new Promise(async (resolve) => {
        const {
          sortBy, sortDesc, page, itemsPerPage,
        } = this.options;
        const response = await this.getItems(
          page,
          itemsPerPage,
          sortBy,
          sortDesc,
        ).then((result) => {
          const data = result.data.items;
          const { total } = result.data;
          return { data, total } || [];
        });
        const items = response.data;
        const { total } = response;

        setTimeout(() => {
          this.loading = false;
          resolve({
            items,
            total,
          });
        }, 1000);
      });
    },
    getItems(page, itemsPerPage, sortBy, sortDesc) {
      const url = `${this.apiURL}?currentPage=${page}&perPage=${itemsPerPage}
        &search=${this.search}&sortBy=${sortBy}&desc=${sortDesc}&${this.queryParams}`;
      const promise = window.axios.get(url).then();
      return promise;
    },
    reset() {
      this.search = '';
    },
    newItem() {
      this.$router.push({ path: `${this.$router.currentRoute.path}/create` });
    },
    openModalDelete(item) {
       this.dialog = true;
       this.item = item;
      },
    deleteItem() {
      this.getDataFromApi()
      .then((data) => {
        this.items = data.items;
      });
      this.toggleStatusDelete = true;
      const url = `${this.apiURLDevice}/${this.item.id}/${this.item.codigo}`;
      window.axios.delete(url)
      .then((response) => {
        this.$store.dispatch('notifications/show', {
          message: response.data.message,
          type: response.data.type,
        });
        this.toggleStatusDelete = false;
        this.dialog = false;
        this.getDataFromApi()
        .then((data) => {
          this.items = data.items;
          this.totalItems = data.total;
        });
      });
    },
  },
};
</script>
